import { GlobalService } from 'src/app/_services/global.service';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { defer, map, Observable, throwError } from 'rxjs';
import { ConnMessageService } from './conn-message.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  filter: any = null
  QOHChange=false;
  activeItem: any = null
  productInfo: any = ''
  locations: any = ''
  private setProductExistInFlight = false;
  // Auto PO
  autoPurchaseOrder:boolean =false;
  isNew = false
  isEdit = false
  isViewOnly = false
  isReject = false

  productName: any = 'any name of your choice'
  descriptionUrl: any = ''
  productDescription: any = ''
  productNotes = ''
  sku: any = ''
  barcode: any = ''
//----\\
altBarcode:any[] = []
altSKUs:any[] = []
altTags:any[] = []

labelPrintingImage: any = ""

  validate = { pd: false, pp: false, pi: false }

  selectedProductType: any = ''
  selectedSellAs: any = ''
  selectedGrouping: any = ''
  selectedDiscount: any = ''
  selectedAgeRestriction: any = ''
  selectedGender: any = ''
  selectedLocations: any = []
  selectedLocationsQOH: any = []

  isTrackStock = false
  isAllowNegativeStock = false
  isSellOnline = false
  priceA: any = 12
  priceB: any = 23
  priceC: any = 34
  costPrice: any = 12
  discountPrice: any = 0
  caseQty = 0
  variantAttributes = []
  variantImages: Array<{ id: string; options: Record<string, string>; image: string | null }> = []
  variantRows: Array<{
    id: string;
    options: Record<string, string>;
    price: number | null;
    cost?: number | null;
    available: number | null;
    image: string | null;
    sku: string;
    barcode: string;
    skuId?: number | string | null;
    shippingWeight?: number | null;
    shippingHeight?: number | null;
    shippingWidth?: number | null;
    shippingLength?: number | null;
    shippingWeightUOM?: number | string | null;
    shippingDimensionUOM?: number | string | null;
  }> = []
  useParentSkuBarcodeForVariants = false;
  variantLocationStocks: Record<string, Record<string, number>> = {}
  variantLocationQohStocks: Record<string, Record<string, number>> = {}
  taxRates: any = []

  isTaxable = false
  isOpenPrice = false
  isPrintAsQR = false
  isReturnable=true

  isNewDepartment = false
  isNewCategory = false
  isNewManufacturer = false
  isNewVendor = false
  printNotesOnReceipt = false
  ShowNotesWhenRingingItem = false

  defaultImage: any = null
  featureImage: any = null
  featureImageIndex: number | null = null
  thImages: any = []
  thImageNames: any = []
  hasGalleryChanged = false

  selectedTaxRate: any = ''
  selectedSellQuantity: any = ''

  defaultPrice = []
  selectedDefaultPrice: any = ''

  //----- shipping information
  selectedShippingWeight: any = ''
  shippingWeight = 0

  selectedShippingDimension: any = ''
  shippingHeight = 0
  shippingWidth = 0
  shippingLength = 0

  //----- tmp data
  pts = {
    t_productName: '',
    descriptionUrl: '',
    sku: '',
    barcode: '',
    priceA: null,
    priceB: null,
    priceC: null,
    costPrice: null,
    discountPrice: null,
    caseQty: null,
    maxLevel: '',
    minLevel: '',
    reorderLevel: '',
    minOrderQty: '',
    maxOrderQty: '',
    autoPurchaseOrder:false,
  //  ----
    altBarcode:[],
    altSKUs:[],
    altTags:[],
    itemSKUId:""
  }

  constructor(
    private _bs: BaseService,
    private _abd: AppBaseDataService,
    private _fb: FormBuilder,
    private http: HttpClient,
    private _connMessage: ConnMessageService
  ) {
    if (!this.productInfo.defaultPrice) {
      this.getProductGeneralInformation().subscribe({
        next: (res: any) => {
          if (res.success) {
            this.productInfo = JSON.parse(JSON.stringify(res.data))
            this.selectedDefaultPrice = this.productInfo.defaultPrice[0]
            this.selectedTaxRate = this.productInfo.taxRate[0]
            this.selectedSellQuantity = this.productInfo.sellQuantity[0]

            //console.log('PRODUCT-INFO', this.productInfo)
          }
        },
        error: () => {
          this.productInfo = this.productInfo || {}
        }
      })
    }

    this.isTaxable = true
    this.pts.sku = this.sku
    this.pts.barcode = this.barcode
    //----\\  


    this.filter = {
      searchText: '',
      selectedProductSellTypeFilter: '',
      selectedDepartment: '',
      selectedCategory: '',
      selectedVendor: '',
      selectedManufacturer: '',
    }
  }

  resetVariables() {
    this.selectedProductType = ''
    this.selectedSellAs = ''
    this.selectedGrouping = ''
    this.selectedDiscount = ''
    this.selectedAgeRestriction = ''
    this.selectedGender = ''
    // ----\\
    this.altBarcode = []
    this.altSKUs = []
    this.altTags = []
    
    this.selectedLocations = []

    this.isTrackStock = false
    this.isAllowNegativeStock = false
    this.isSellOnline = false
    this.priceA = ''
    this.priceB = ''
    this.priceC = ''
    this.costPrice = ''
    this.discountPrice = 0
    this.caseQty = 0
    this.variantAttributes = []
    this.variantImages = []
    this.variantRows = []
    this.useParentSkuBarcodeForVariants = false
    this.variantLocationStocks = {}
    this.variantLocationQohStocks = {}

    this.isTaxable = false
    this.isOpenPrice = false
    this.isPrintAsQR = false

    this.isNewDepartment = false
    this.isNewCategory = false
    this.isNewManufacturer = false
    this.isNewVendor = false
      this.printNotesOnReceipt = false
      this.ShowNotesWhenRingingItem = false

      this.featureImage = null
      this.featureImageIndex = null
      this.thImages = []
      this.thImageNames = []
      this.hasGalleryChanged = false

      this.selectedTaxRate = ''
    this.selectedSellQuantity = ''

    this.defaultPrice = []
    this.selectedDefaultPrice = ''

    //----- shipping information
    this.selectedShippingWeight = this._abd.WeightUOM[0]
    this.shippingWeight = 0

    this.selectedShippingDimension = this._abd.DimensionUOM[3]
    this.shippingHeight = 0
    this.shippingWidth = 0
    this.shippingLength = 0
    this.pts.maxLevel = '';
    this.pts.minLevel = '';
    this.pts.reorderLevel = '';
    this.pts.minOrderQty = '';
    this.pts.maxOrderQty = '';
    this.pts.autoPurchaseOrder = false;
  }

  getProductGeneralInformation() {
    let url = environment.InventoryBaseURL + environment.GeneralDetail;

    return this._bs.httpGet(url).pipe(map(res => {
      return res;
    }))
  }

  getVariantOptionPresets() {
    const url = environment.InventoryBaseURLSTG + 'GetAllVariantOptionPresets'
    return this._bs.httpGet(url).pipe(map(res => {
      return res
    }))
  }

  /** Product saves attempted while offline are blocked up front with the no-internet alert
   *  (network failures mid-request are alerted by ErrorsInterceptor). */
  private withInternetAlert<T>(request: () => Observable<T>): Observable<T> {
    return defer(() => {
      if (typeof navigator !== 'undefined' && navigator.onLine === false) {
        this._connMessage.showNoInternetToast(0)
        return throwError(() => new Error(this._connMessage.noInternetMessage))
      }
      return request()
    })
  }

  saveProduct(model: any) {
    //console.log(model)
    const url = environment.InventoryBaseURLSTG + environment.ItemModule + 'v2'
    return this.withInternetAlert(() => this._bs.httpPost(url, model, true).pipe(map(res => {
      return res
    })))
  }

  updateProduct(model: any, id: any) {
    //console.log(model)
    const url = environment.InventoryBaseURLSTG + environment.ItemModule + 'v2/' + id
    return this.withInternetAlert(() => this._bs.httpPut(url, model, true).pipe(map(res => {
      return res
    })))
  }

  saveProductV3(model: any) {
    const url = environment.InventoryBaseURLSTG + 'v3/Items'
    return this.withInternetAlert(() => this._bs.httpPost(url, model, true).pipe(map(res => {
      return res
    })))
  }

  updateProductV3(model: any, id: any) {
    const url = environment.InventoryBaseURLSTG + 'v3/Items/' + id
    return this.withInternetAlert(() => this._bs.httpPut(url, model, true).pipe(map(res => {
      return res
    })))
  }

  deleteProduct(id: string) {

    let url = environment.InventoryBaseURL + environment.ItemModule + "/" + id;
    return this._bs.httpDelete(url).pipe(map(res => {
      return res;
    }))
  }

  getAllProductList(paras: any) {
    let url = environment.InventoryBaseURL + environment.GetStockStatusReportV3;

    return this._bs.httpGetParams(url, paras).pipe(map(res => {
      return res
    }))
  }

    searchProductForLoyaltyProgram(paras: any) {
        let url = environment.InventoryBaseURL + environment.ItemModule;

        return this._bs.httpGetParams(url, paras).pipe(map(res => {
            return res
        }))
    }

  getAllProductList4Inventory(paras: any, qryParas = null, skipInterceptor: boolean = false) {
    let url = environment.InventoryBaseURLSTG + environment.ItemModule;
    if(qryParas) url +=  qryParas;
    return this._bs.httpGetParams(url, paras, false, true, skipInterceptor).pipe(map(res => {
      return res
    }))
  }

  getStoreSetupInventoryV3(pageNo: number = 0, pageSize: number = 10) {
    const url = `${environment.InventoryBaseURLSTG}v3/Items?pageNo=${pageNo}&pageSize=${pageSize}`;
    return this._bs.httpGet(url).pipe(map(res => {
      return res
    }))
  }

  notifyFirstProductCreated(firstProductHint?: boolean): void {
    if (this.isProductExistAlreadyMarked() || this.setProductExistInFlight) {
      return;
    }

    if (firstProductHint === false) {
      return;
    }

    if (firstProductHint === true) {
      this.callSetProductExist();
      return;
    }

    this.getStoreSetupInventoryV3(0, 2).subscribe({
      next: (res: any) => {
        const totalProducts = this.resolveInventoryCount(res);
        if (totalProducts === 1) {
          this.callSetProductExist();
        }
      },
      error: () => { }
    });
  }

  private callSetProductExist(): void {
    if (this.isProductExistAlreadyMarked() || this.setProductExistInFlight) {
      return;
    }

    const requestPayload = this.resolveUserBusinessRequest();
    if (!requestPayload) {
      return;
    }

    this.setProductExistInFlight = true;
    const url = environment.AuthenticationURL + 'businesssetup/product-exist';

    this._bs.httpPost(url, requestPayload, false, false).subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.markProductExistLocally();
        }
        this.setProductExistInFlight = false;
      },
      error: () => {
        this.setProductExistInFlight = false;
      }
    });
  }

  private resolveUserBusinessRequest(): { UserId: string; BusinessId: number } | null {
    const userId = this.resolveUserIdForAuthRequest();
    const businessId = this.resolveBusinessIdForAuthRequest();
    if (!userId || businessId <= 0) {
      return null;
    }

    return {
      UserId: userId,
      BusinessId: businessId
    };
  }

  private resolveUserIdForAuthRequest(): string {
    const fromGlobal = String(
      GlobalService.userInfo?.userID
      ?? GlobalService.userInfo?.userId
      ?? ''
    ).trim();
    if (fromGlobal) {
      return fromGlobal;
    }

    const fromPersonal = this.safeParseSession<any>('personal-Info');
    const personalUserId = String(fromPersonal?.userID ?? fromPersonal?.userId ?? '').trim();
    if (personalUserId) {
      return personalUserId;
    }

    const fromRequired = this.safeParseSession<any>('requiredInfo');
    return String(fromRequired?.UserId ?? fromRequired?.userId ?? '').trim();
  }

  private resolveBusinessIdForAuthRequest(): number {
    const parseBusinessId = (value: any): number => {
      const parsed = Number(value);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
    };

    const fromGlobal = parseBusinessId(
      GlobalService.userInfo?.businessSetup?.[0]?.businessId
      ?? GlobalService.userInfo?.businessSetup?.[0]?.id
    );
    if (fromGlobal > 0) {
      return fromGlobal;
    }

    const fromBusinessInfo = this.safeParseSession<any>('business-Info');
    const fromBusinessSession = parseBusinessId(fromBusinessInfo?.businessId ?? fromBusinessInfo?.id);
    if (fromBusinessSession > 0) {
      return fromBusinessSession;
    }

    const fromRequired = this.safeParseSession<any>('requiredInfo');
    return parseBusinessId(fromRequired?.BusinessId ?? fromRequired?.businessId);
  }

  private safeParseSession<T = any>(key: string): T | null {
    try {
      const value = sessionStorage.getItem(key);
      if (!value) {
        return null;
      }
      return JSON.parse(value) as T;
    } catch {
      return null;
    }
  }

  private resolveInventoryCount(res: any): number {
    if (!res?.success) {
      return 0;
    }

    const items = Array.isArray(res?.data)
      ? res.data
      : Array.isArray(res?.data?.items)
        ? res.data.items
        : Array.isArray(res?.items)
          ? res.items
          : [];

    const totalRecordsRaw = res?.totalRecords ?? res?.data?.totalRecords;
    const totalRecords = Number(totalRecordsRaw);
    if (Number.isFinite(totalRecords) && totalRecords >= 0) {
      return totalRecords;
    }

    return items.length;
  }

  private getProductExistStorageKey(): string {
    const setup = GlobalService.userInfo?.businessSetup?.[0] || {};
    const identity =
      setup?.businessId ||
      setup?.businessNameWithDomain ||
      setup?.businessName ||
      GlobalService.userInfo?.userID ||
      GlobalService.userInfo?.userId ||
      'default';
    return `product-exist:${identity}`;
  }

  private isProductExistAlreadyMarked(): boolean {
    try {
      return localStorage.getItem(this.getProductExistStorageKey()) === '1';
    } catch {
      return false;
    }
  }

  private markProductExistLocally(): void {
    try {
      localStorage.setItem(this.getProductExistStorageKey(), '1');
    } catch { }
  }

  getAllProductList4InventoryV3(paras: any, qryParas = null, skipInterceptor: boolean = false) {
    let url = environment.InventoryBaseURLSTG + 'v3/Items';
    if (qryParas) url += qryParas;
    return this._bs.httpGetParams(url, paras, false, true, skipInterceptor).pipe(map(res => {
      return res
    }))
  }

  getProductV3ById(id: string | number) {
    const url = environment.InventoryBaseURLSTG + 'v3/Items/' + id;
    return this._bs.httpGet(url).pipe(map(res => {
      return res
    }))
  }

  ExportInventoryCSV(paras: any) {

    let url = environment.InventoryBaseURL + environment.ItemModule + "/ExportInventoryItems";
    let _headers = this._bs.GetAuthHeader();
    return this.http.get(url + '?' + paras, { responseType: 'arraybuffer', headers: _headers }).pipe(map(res => {
      return res
    }))
  }

  import(paras: any) {
    const formData = new FormData();
    formData.append('file', paras.file);
    formData.append('locationId', paras.locationid.toString());
    let additPram = "";
    if (paras.importOption !== undefined) {
      additPram = paras.importOption + "=true"
    }
    let url = environment.InventoryBaseURL + environment.ImportInventory + "?" + additPram
    return this._bs.httpPost(url, formData).pipe(map(res => {
      return res
    }))
  }

  importV2(paras: any) {
    const formData = new FormData();
    formData.append('file', paras.file);
    formData.append('locationId', paras.locationid.toString());
    formData.append('importType', paras.importType);
    let url = environment.InventoryBaseURL + environment.ImportInventory + "?" + paras.importOption + "=true";
    return this._bs.httpPost(url, formData).pipe(map(res => {
      return res
    }))
  }

  importQuick(file: File, mode: string, locationId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('mode', mode);
    if (locationId !== undefined && locationId !== null) { formData.append('locationId', locationId.toString()); }
    return this._bs.httpPost(environment.InventoryBaseURLSTG + 'v3/items/import/quick', formData);
  }

  importDetail(file: File, mode: string, locationId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('mode', mode);
    if (locationId !== undefined && locationId !== null) { formData.append('locationId', locationId.toString()); }
    return this._bs.httpPost(environment.InventoryBaseURLSTG + 'v3/items/import/detail', formData);
  }

  getImportJob(jobId: string) {
    return this._bs.httpGet(environment.InventoryBaseURLSTG + 'v3/items/import/' + encodeURIComponent(jobId), false);
  }

  searchQuantity(locationId: number, skuCode: string, productId: string) {
    let url = environment.InventoryBaseURL + "GetStockStatus" + "?skucode=" + skuCode +
      "&locationId=" + locationId + "&productId=" + productId;
    return this._bs.httpGet(url).pipe(map(res => {
      return res;
    }))
  }

  transferInventoryPost(data: any) {
    let url = environment.InventoryBaseURL + 'Transfer/StockTransferV2';
    return this._bs.httpPost(url, JSON.stringify(data)).pipe(map(res => {
      return res;
    }))
  }

  inventoryAdjustmentPost(data: any) {
    let url = environment.InventoryBaseURL + 'InventoryAdjustment';
    return this._bs.httpPost(url, JSON.stringify(data)).pipe(map(res => {
      return res;
    }))
  }


  getTransfersList(senderLocation: string, receiverLocation: string,
    startDate: string, endDate: string, transfersStatus: number,
    transfersStatusCheck: number,
    pageNo, pageSize, filterValue = '',isReciveList=false) {
      if(isReciveList){
        let url = environment.InventoryBaseURL + 'Transfer/GetStockTransfersV2'
        + "?locationIdFrom=" + receiverLocation + "&locationIdTo="
        + senderLocation + "&startDate=" + startDate + "&endDate=" + endDate
        + '&TransfersStatusCheck=' + transfersStatusCheck
        + '&filterValue=' + filterValue
        + "&transfersStatus=" + transfersStatus + "&pageNo=" + pageNo + "&pageSize=" + pageSize;
  
      return this._bs.httpGet(url).pipe(map(response => {
        return response;
      }))
      }
      else
      {
        let url = environment.InventoryBaseURL + 'Transfer/GetStockTransfersV2'
        + "?locationIdFrom=" + senderLocation + "&locationIdTo="
        + receiverLocation+ "&startDate=" + startDate + "&endDate=" + endDate
        + '&TransfersStatusCheck=' + transfersStatusCheck
        + '&filterValue=' + filterValue
        + "&transfersStatus=" + transfersStatus + "&pageNo=" + pageNo + "&pageSize=" + pageSize;
  
      return this._bs.httpGet(url).pipe(map(response => {
        return response;
      }))
      }
   
  }

  searchSingleTransferOrder(transferId: any, what: any) {
    let url = environment.InventoryBaseURL + environment.SearchStockTransfer + "/" + transferId
    url = url + '?TransfersStatusCheck=' + what

    return this._bs.httpGet(url).pipe(map(response => {
      return response;
    }))
  }

  viewInventoryAdjustmentDetails(adjustmentId: any) {
    let url = environment.InventoryBaseURL + "InventoryAdjustment" + "/" + adjustmentId
    return this._bs.httpGet(url).pipe(map(response => {
      return response;
    }))
  }
  getInventoryAdjustmentList(data: any) {
    let url = environment.InventoryBaseURL + 'GetInventoryAdjustment';
    return this._bs.httpPost(url, JSON.stringify(data)).pipe(map(res => {
      return res;
    }))
  }

  getItemStockStatus(skuId, locations) {
    let url = `${environment.InventoryBaseURL}GetItemStockStatus?itemSKUId=${skuId}&locationId=${locations}`
    return this._bs.httpGet(url).pipe(map(res => {
      return res;
    }))
  }

  getItemStockStatusV2(itemIdOrCode: string | number) {
    const itemId = encodeURIComponent(String(itemIdOrCode ?? '').trim())
    let url = `${environment.InventoryBaseURLSTG}v3/GetItemStockStatus?itemId=${itemId}`
    return this._bs.httpGet(url).pipe(map(res => {
      return res;
    }))
  }

  //   getInventoryAdjustmentList(senderLocation: string,
  //     startDate: string, endDate: string,AdjustmentType: String,
  //     pageNo, pageSize, filterValue='') {
  //     let url = environment.InventoryBaseURL + 'GetInventoryAdjustment'
  //       + "?LocationIds=" + senderLocation +  "&startDate=" + startDate + "&endDate=" + endDate
  //       + '&AdjustmentType='+AdjustmentType
  //       + '&filterValue=' + filterValue
  //      + "&pageNo=" + pageNo + "&pageSize=" + pageSize;

  //     return this._bs.httpPost(url).pipe(map(response => {
  //       return response;
  //     }))
  //   }


}
